// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__35MJ9","rootCenter":"LoadMoreObserver_rootCenter__wTYSe","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__21PYq"};